import Form from "./Form";
import { useToast } from "@chakra-ui/react";
import {
  CreateCollectionMutationVariables,
  useCreateCollectionMutation,
} from "../../generated/graphql";
import { useNavigate } from "react-router-dom";

const Create = () => {
  const [createCollection] = useCreateCollectionMutation();
  const navigation = useNavigate();
  const toast = useToast();
  const handleCreate = async (data: CreateCollectionMutationVariables) => {
    try {
      await createCollection({
        variables: {
          data: data.data,
        },
      });

      return toast({
        status: "success",
        title: "Başarılı",
        description: "Collection added",
        duration: 1000,
        onCloseComplete: () => {
          return navigation("/collection");
        },
      });
    } catch (error: any) {
      return toast({
        status: "error",
        title: "Hata",
        description: error.message || "Bir hata oluştu",
        duration: 1000,
      });
    }
  };
  return <Form handleCreate={handleCreate} actionType="CREATE" />;
};

export default Create;
